import React, {useContext, useEffect, useState} from "react"
import {Button, Box, Typography} from "@mui/material"
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import Grid from '@mui/material/Grid';
import makeStyles from "@material-ui/core/styles/makeStyles";
import {useHistory} from "react-router";
import {Item} from "./Item";
import { get } from "@api/segment"
import {CreatePreview} from "../Segments/createPreview";

const useStyles = makeStyles({
    main: {
        marginTop: '2em',
    },
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
    },
});

export const Segments = () => {
    const classes = useStyles();
    const history = useHistory();
    const [segment, setSegment] = useState([])
    const {loading, setLoading} = useContext(LoadingContext);
    const {setErrorMessage} = useContext(MessageContext);

    const createSegment = (id) => {
        history.push(`/create-segment/`)
    }

    const onRemoveSegment = (id) => {
        setSegment((segments) => segments.filter((segment) => segment.id !== id))
    }

    useEffect(() => {
        const loadSegment = async () => {
            try {
                setLoading(true);
                setErrorMessage(null);

                const [segment] = await get()

                setSegment(segment)
            } catch (e) {
                setErrorMessage(e);
            }
            setLoading(false);
        }

        loadSegment()
    }, [])

    if (!loading && !segment.length) return <CreatePreview edit={createSegment}/>

    return (
        <>
            <Grid className={classes.main} container spacing={2}>
                <Grid item xs={12}>
                    <Box display={"flex"} justifyContent={"space-between"}>
                        <Typography className={classes.title} component="h2">My Segments</Typography>
                        <Button variant="contained" onClick={() => createSegment()}>Create new segment</Button>
                    </Box>
                </Grid>
            </Grid>
            {!segment.length ? 'no data for now....' : ''}
            {segment.map(({name, segments, id}, ind) => (
                <Item key={ind} id={id} onRemoveSegment={onRemoveSegment} name={name} data={segments}/>
            ))}
        </>
    )
}